<template>
  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="实名认证名称">
          <el-input placeholder="请输入实名认证名称" v-model="formInline.search"></el-input>
        </el-form-item>
        <el-form-item label="审核状态">
          <el-select v-model="formInline.status" placeholder="请选择审核状态" clearable>
            <el-option label="未审核" value="0"></el-option>
            <el-option label="审核通过" value="1"></el-option>
            <el-option label="审核不通过" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加实名认证</el-button>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="name" label="姓名" width="100"></el-table-column>
            <el-table-column prop="phone" label="手机号" width="120"></el-table-column>
            <el-table-column prop="bank_card_number" label="银行卡号" width="160"></el-table-column>
            <el-table-column prop="bank" label="开户行" width="120"></el-table-column>
            
            <!-- 银行卡正面图片 -->
            <el-table-column label="银行卡正面" width="120">
              <template slot-scope="scope">
                <div v-if="scope.row.idCardFront && scope.row.idCardFront.length > 0">
                  <el-image 
                    style="width: 80px; height: 50px; cursor: pointer;" 
                    :src="scope.row.idCardFront[0].file_path" 
                    :preview-src-list="[scope.row.idCardFront[0].file_path]"
                    fit="cover">
                  </el-image>
                </div>
                <span v-else>无图片</span>
              </template>
            </el-table-column>
            
            <!-- 银行卡背面图片 -->
            <el-table-column label="银行卡背面" width="120">
              <template slot-scope="scope">
                <div v-if="scope.row.idCardBack && scope.row.idCardBack.length > 0">
                  <el-image 
                    style="width: 80px; height: 50px; cursor: pointer;" 
                    :src="scope.row.idCardBack[0].file_path" 
                    :preview-src-list="[scope.row.idCardBack[0].file_path]"
                    fit="cover">
                  </el-image>
                </div>
                <span v-else>无图片</span>
              </template>
            </el-table-column>
            
            <!-- 审核状态 -->
            <el-table-column prop="status" label="审核状态" width="100">
              <template slot-scope="scope">
                <el-tag 
                  :type="scope.row.status == 1 ? 'success' : scope.row.status == 2 ? 'danger' : 'warning'"
                  size="small">
                  {{ getStatusText(scope.row.status) }}
                </el-tag>
              </template>
            </el-table-column>

            <el-table-column prop="sort" label="排序" width="80"></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            
            <el-table-column fixed="right" label="操作" width="180">
              <template slot-scope="scope">
                <!-- 审核按钮 -->
                <el-button 
                  v-if="scope.row.status == 0" 
                  @click="auditClick(scope.row, 1)" 
                  type="text" 
                  size="small"
                  style="color: #67C23A;">
                  通过
                </el-button>
                <el-button 
                  v-if="scope.row.status == 0" 
                  @click="auditClick(scope.row, 2)" 
                  type="text" 
                  size="small"
                  style="color: #F56C6C;">
                  不通过
                </el-button>
                <el-button 
                  v-if="scope.row.status != 0" 
                  @click="resetAuditClick(scope.row)" 
                  type="text" 
                  size="small">
                  重置审核
                </el-button>
                
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small" style="color: #F56C6C;">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <!-- 审核对话框 -->
    <el-dialog
      :title="auditDialog.title"
      :visible.sync="auditDialog.visible"
      width="30%"
      center>
      <span>{{ auditDialog.content }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="auditDialog.visible = false">取 消</el-button>
        <el-button type="primary" @click="confirmAudit">确 定</el-button>
      </span>
    </el-dialog>
    
    <Add :open_add="open_add" v-if="open_add" @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :certificationx_id="certificationx_id" v-if="open_edit" @close="closeEdit"></Edit>
  </div>
</template>

<script>
import CertificationxApi from '@/api/certificationx.js';
import Add from './part/add.vue';
import Edit from './part/edit.vue';

export default {
  components: {
    Add,
    Edit,
  },
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索表单对象*/
      form: {},
      formInline: {
        search: "",
        status: ""
      },

      open_add: false,
      open_edit: false,
      certificationx_id: "",
      
      /*审核对话框*/
      auditDialog: {
        visible: false,
        title: "",
        content: "",
        currentRow: null,
        auditStatus: 0
      }
    };
  },
  created() {
    /*获取列表*/
    this.getTableList();
  },
  methods: {
    /*获取审核状态文本*/
    getStatusText(status) {
      switch(status) {
        case 0: return '未审核';
        case 1: return '审核通过';
        case 2: return '审核不通过';
        default: return '未知';
      }
    },
    
    /*关闭添加*/
    closeAdd(e) {
      this.open_add = false;
      this.getTableList();
    },
    
    closeEdit(e) {
      this.open_edit = false;
      this.getTableList();
    },
    
    getData() {
      this.curPage = 1;
      this.getTableList();
    },

    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = { ...this.formInline };
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;
      
      CertificationxApi.list(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {
          self.loading = false;
          console.error('获取列表失败:', error);
        });
    },

    /*添加任务*/
    addClick() {
      this.open_add = true;
    },

    /*编辑活动*/
    editClick(row) {
      this.certificationx_id = row.certificationx_id;
      this.open_edit = true;
    },

    /*审核操作*/
    auditClick(row, status) {
      this.auditDialog.currentRow = row;
      this.auditDialog.auditStatus = status;
      
      if (status === 1) {
        this.auditDialog.title = "审核通过";
        this.auditDialog.content = `确定要通过 ${row.name} 的实名认证申请吗？`;
      } else {
        this.auditDialog.title = "审核不通过";
        this.auditDialog.content = `确定不通过 ${row.name} 的实名认证申请吗？`;
      }
      
      this.auditDialog.visible = true;
    },
    
    /*重置审核*/
    resetAuditClick(row) {
      this.auditDialog.currentRow = row;
      this.auditDialog.auditStatus = 0;
      this.auditDialog.title = "重置审核状态";
      this.auditDialog.content = `确定要将 ${row.name} 的审核状态重置为未审核吗？`;
      this.auditDialog.visible = true;
    },
    
    /*确认审核*/
    confirmAudit() {
      let self = this;
      let row = self.auditDialog.currentRow;
      
      CertificationxApi.audit({
        certificationx_id: row.certificationx_id,
        status: self.auditDialog.auditStatus
      }, true)
        .then(data => {
          self.$message({
            message: data.msg,
            type: 'success'
          });
          self.auditDialog.visible = false;
          self.getTableList();
        })
        .catch(error => {
          console.error('审核操作失败:', error);
        });
    },

    /*删除*/
    deleteClick(row) {
      let self = this;
      self.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(() => {
        CertificationxApi.del({
          certificationx_id: row.certificationx_id
        }, true)
        .then(data => {
          if (data.code == 1) {
            self.$message({
              message: '删除成功',
              type: 'success'
            });
            self.getTableList();
          } else {
            self.$message.error('删除失败');
          }
        })
        .catch(error => {
          self.$message.error('删除失败');
        });
      })
      .catch(() => {});
    }
  }
};
</script>

<style>
/* 图片预览样式 */
.el-image {
  border-radius: 4px;
}

/* 操作按钮间距 */
.el-button--text {
  margin-right: 8px;
}

/* 表格样式优化 */
.table-wrap {
  margin-top: 20px;
}

/* 状态标签样式 */
.el-tag {
  margin: 2px;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/certificationx/index/index.vue